import gql from 'graphql-tag';

export const GET_ALL_VODSETS = gql`
  {
    vodsetList {
      id
      name
      status
      priority
      processing
      updated_at
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/vodsets/all.js